<script setup lang="ts">
import type { FilterCategory, FilterDraft, FilterToggle } from '#shared/mobile-filter-drawer'
import { faBookmark, faBookSection, faBuildingColumns, faPenNib } from '@fortawesome/pro-light-svg-icons'

const openFilter = defineModel('openFilter', { default: false })

const { selectedAuthor, authorOptions, hasLawComment, showOnlyFavorites, legalAreaOptions, selectedLegalArea, countWithFilters } = useLawFilters()

const categories = computed<FilterCategory[]>(() => [
  { id: 'rettsområde', label: 'Rettsområde', icon: faBuildingColumns, options: legalAreaOptions.value, resetAriaLabel: 'Nullstill rettsområde' },
  { id: 'forfatter', label: 'Forfattere', icon: faPenNib, options: authorOptions.value, resetAriaLabel: 'Nullstill forfatter' },
])

const toggles = computed<FilterToggle[]>(() => [
  { id: 'lovkommentar', label: 'Med lovkommentar', icon: faBookSection },
  { id: 'favoritter', label: 'Favoritter', icon: faBookmark },
])

const initial = computed<FilterDraft>(() => ({
  categories: { rettsområde: selectedLegalArea.value, forfatter: selectedAuthor.value },
  toggles: { lovkommentar: hasLawComment.value, favoritter: showOnlyFavorites.value },
}))

function count(draft: FilterDraft) {
  return countWithFilters({
    hasLawComment: draft.toggles.lovkommentar ?? false,
    showOnlyFavorites: draft.toggles.favoritter ?? false,
    selectedLegalArea: draft.categories.rettsområde ?? [],
    selectedAuthor: draft.categories.forfatter ?? [],
  })
}

function onCommit(draft: FilterDraft) {
  hasLawComment.value = draft.toggles.lovkommentar ?? false
  showOnlyFavorites.value = draft.toggles.favoritter ?? false
  selectedLegalArea.value = [...(draft.categories.rettsområde ?? [])]
  selectedAuthor.value = [...(draft.categories.forfatter ?? [])]
}
</script>

<template>
  <MobileFilterDrawer
    v-model:open="openFilter"
    :categories="categories"
    :toggles="toggles"
    :initial="initial"
    :count="count"
    :min-height="55"
    @commit="onCommit"
  />
</template>
